export default __webpack_public_path__ + "static/media/480_store01-en-web.d5e1d3cd.png";